import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ContentChild,
  ElementRef,
  ViewChild,
  EventEmitter,
  Output,
} from '@angular/core';
import { ScreenBreakpointObserverService } from 'src/app/shared/foundation/utils/breakpoint-observer.service';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
})
export class ContentLayoutComponent implements OnInit {
  isMobileLayout = false;
  isExpanded = false;

  @ContentChild('start', { static: false }) public start: TemplateRef<any>;
  @ContentChild('center', { static: false }) public center: TemplateRef<any>;
  @ContentChild('end', { static: false }) public end: TemplateRef<any>;

  @Output() sectionChangedEmitter = new EventEmitter<any>();

  constructor(private bpObserverService: ScreenBreakpointObserverService) {}

  ngOnInit(): void {
    this.bpObserverService.screenSizeObserver.subscribe({
      next: (res) => {
        if (res.length <= 2) {
          this.isMobileLayout = true;
        } else {
          this.isMobileLayout = false;
        }
      },
    });
  }

  toggleListViewExpansion() {
    this.isExpanded = !this.isExpanded;
  }

  onSectionChanged(event: any) {
    this.sectionChangedEmitter.emit(event);
  }
}
